<!-- Show the full app layout only if the user is logged in -->
<div *ngIf="isLoggedIn">
    <!-- Header component with app title and reload action -->
	<app-header [title]="title" (reloadPage)="reloadPage()"></app-header>
    <!-- Navigation sidebar, toggled based on layout class and footer visibility -->
	<app-nav *ngIf="showNav" [class]="layoutCssClass" [ngClass]="{ 'no-footer': !showFooter }"
		[expand]="expand" (setLayoutClass)="setLayoutClass()" (reloadPage)="reloadPage()"></app-nav>
    <!-- Main content container with dynamic layout classes for nav/footer visibility -->
	<content [class]="layoutCssClass" [ngClass]="{ 'no-nav': !showNav, 'no-footer': !showFooter }">
		<!-- Angular placeholder to render routed components -->
		<router-outlet></router-outlet>
	</content>
    <!-- Footer shown only if showFooter is true -->
	<app-footer *ngIf="showFooter"></app-footer>
</div>
<!-- Feedback component always available, outside login state -->
<app-feedback></app-feedback>
<!-- Dynamic modal container that loads any component at runtime using inputs/outputs -->
<div *ngIf="modal" class="modal-window">
	<div class="locked"></div>
	<ng-container
		[ngComponentOutlet]="modal.type"
		[ndcDynamicInputs]="modal.inputs"
		[ndcDynamicOutputs]="modal.outputs">
	</ng-container>
</div>
<!-- Shows 'Authenticating...' loader while login is in progress but access is not denied -->
<div *ngIf="!isLoggedIn && layoutCssClass !== 'noaccess'">
    <div class="auth">Authenticating...</div>
</div>
<!-- Renders access denied component if the user has no roles or is blocked -->
<app-access *ngIf="layoutCssClass === 'noaccess'"></app-access>
<!-- Shows global error message if error string is not empty -->
<app-error *ngIf="error !== ''" [message]="error"></app-error>
<!-- Shows alert modal with confirm and cancel actions -->
<div *ngIf="showAlert" class="modal-window">
	<div class="locked"></div>
	<app-alert
		[title]="alertTitle"
		[message]="alertMessage"
		[continueText]="alertContinueText"
		[cancelText]="alertCancelText"
		(continueEvent)="alertContinue()"
		(cancelEvent)="alertCancel()">
	</app-alert>
</div>
<!-- Shows global loader spinner while app is initializing -->
<sdk-loading [isLoading]="isLoading"></sdk-loading>
